module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img58.be173492.jpg";